<script>
import { mapMutations } from 'vuex';

export default {
  methods:{
    ...mapMutations({
      SET_LOADING: 'app/SET_LOADING',
    })
  },

  async mounted(){
    await this.SET_LOADING(false);
  }
};
</script>
